import { useEffect, useState } from 'react';
import { UseFormClearErrors, UseFormSetValue } from 'react-hook-form';
import { OnSelectChange } from '@ui/src';
import { CorporateFormValues } from '../../../../hoc/new-application/types';

const useStepTwoValues = ({
  values,
  index,
  type,
  setValue,
  clearErrors,
  setValuesList,
  value,
}: {
  values: {
    id: string;
    name: string;
    monthlyTurnoverRangeId: string;
  }[];
  index: number;
  type: 'suppliers' | 'customers';
  setValue: UseFormSetValue<CorporateFormValues>;
  clearErrors: UseFormClearErrors<CorporateFormValues>;
  setValuesList: (
    data: {
      id: string;
      name: string;
      monthlyTurnoverRangeId: string;
    }[],
  ) => void;
  value: {
    id: string;
    name: string;
    monthlyTurnoverRangeId: string;
  };
}) => {
  const [nameValue, setNameValue] = useState('');

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement> | OnSelectChange,
  ) => {
    const nextValues = values.map((item, valueIndex) => {
      const result = { ...item };

      if (index === valueIndex) {
        if (e.target.name === `${type}-monthlyTurnoverRangeId-${index}`) {
          result.monthlyTurnoverRangeId = e.target.value as string;
        } else {
          result.name = e.target.value as string;
          setNameValue(e.target.value as string);
        }
      }

      return result;
    });

    setValue(type, nextValues);
    clearErrors([type]);
    setValuesList(nextValues);
  };

  const deleteValue = (id: string) => {
    const nextValues = values.filter((item) => item.id !== id);

    setValue(type, nextValues);

    setValuesList(nextValues);
  };

  useEffect(() => {
    if (value && value.name) {
      setNameValue(value.name);
    }
  }, [value]);

  return {
    nameValue,
    onChange,
    deleteValue,
  };
};

export default useStepTwoValues;
